module.exports = __webpack_public_path__ + "img/documents_blue.ddd530f5.svg";